import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChatIcon from '@mui/icons-material/Chat';

interface Props {
  open: boolean;
  expertName: string;
  onClose: () => void;
  onBookAppointment: () => void;
  onOpenChat: () => void;
}

export const ConnectionSuccessDialog: React.FC<Props> = ({
  open,
  expertName,
  onClose,
  onBookAppointment,
  onOpenChat,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <CheckCircleOutlineIcon color="success" />
      Заявку надіслано!
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        Заявка на приєднання до <strong>{expertName}</strong> очікує на схвалення. Але вже зараз
        ви можете записатися на прийом або розпочати спілкування в чаті.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ flexDirection: 'column', gap: 1, px: 3, pb: 2 }}>
      <Button
        fullWidth
        variant="contained"
        startIcon={<CalendarMonthIcon />}
        onClick={onBookAppointment}
      >
        Записатися на прийом
      </Button>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<ChatIcon />}
        onClick={onOpenChat}
      >
        Написати в чат
      </Button>
      <Button fullWidth onClick={onClose} color="inherit">
        Закрити
      </Button>
    </DialogActions>
  </Dialog>
);
